import React from 'react';
import { Grid, Typography } from '@mui/material';

interface PropsType {
  displayKey: string;
  value: number | string;
}

function SingleCharge({ displayKey, value }: PropsType) {
  return (
    <Grid container justifyContent={'space-between'} sx={{ mb: 1, alignItems: 'center' }}>
      <Grid item xs={8} sm={7}>
        <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'text.secondary' }}>{displayKey}</Typography>
      </Grid>
      <Grid item xs={4} sm={5}>
        <Typography sx={{ fontSize: '14px', fontWeight: 600, color: 'common.black', textAlign: 'right' }}>
          {value}
        </Typography>
      </Grid>
    </Grid>
  );
}

export default SingleCharge;
